import { Card, TextField, CardContent, Button, FormControl, Grid } from '@mui/material';
import { ArrowRightCircle, Save } from 'react-feather';

import { LinearLoading } from '../../../../common'

export const GeneralInfoStep = ({ useFetchInit }) => {

    const {
        globalStates,
        Forms,
        FetchData,
        Actions
    } = useFetchInit
    
    const { formOpeningMode, loadingSubmitForm } = globalStates

    const { FormScreen } = Forms
    const { formState, onInputChange } = FormScreen

    const { fetchSpecificManagement } = FetchData
    const { loadingFetchSpecificManagement } = fetchSpecificManagement

    const {
        onSubmitForm,
        handleClickContinue
    } = Actions

    const readOnlyMode = formOpeningMode==='READONLY'

    return (
        <div className='content'>
            <Card style={{zIndex:'1'}}>
                <CardContent>
                    <div className='h4 mt-1 mb-1'>
                        {formState.idgestion > 0
                            ? 'Actualizar Registro'
                            : 'Crear Registro'}
                    </div>
                    <div className="border-bottom border-dark"></div>
                    {loadingFetchSpecificManagement && ( <LinearLoading /> )}

                    <div className="pt-3"></div>
                    <p className='text-danger'>* campos obligatorios</p>
                    <div className="pt-2"></div>

                    <form onSubmit={onSubmitForm}>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            {/* <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="fecha"
                                        name="fecha"
                                        value={formState.fecha}
                                        onChange={onInputChange}
                                        label="Fecha"
                                        size="small"
                                        type="date"
                                        variant="standard"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            readOnly: loadingSubmitForm,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid> */}
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControl fullWidth>
                                    <label htmlFor="titulo">* Título</label>
                                    <TextField
                                        id="titulo"
                                        name="titulo"
                                        value={formState.titulo}
                                        onChange={onInputChange}
                                        // label='Marca'
                                        size='small'
                                        type="text"
                                        variant={readOnlyMode? 'filled': 'outlined'}
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: readOnlyMode,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-4"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        id='descripcion'
                                        name='descripcion'
                                        value={ formState.descripcion } 
                                        onChange={ onInputChange }
                                        size='small'
                                        placeholder='Descripcion'
                                        type='text'
                                        multiline
                                        rows={5}
                                        variant={readOnlyMode? 'filled': 'outlined'}
                                        InputProps={{
                                            readOnly: readOnlyMode
                                        }}
                                        
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-4"></div>
                        <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
                            <Grid item xs={12}>
                                <div className="text-center">
                                    {(!readOnlyMode)&&(
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            disabled={readOnlyMode}
                                            style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                                        >
                                            <Save />
                                        </Button>
                                    )}
                                    &nbsp;
                                    {(formState.idgestion > 0)&&(
                                        <Button
                                            variant="contained"
                                            type="button"
                                            onClick={handleClickContinue}
                                            style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                        >
                                            <ArrowRightCircle/>
                                        </Button>
                                    )}
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
